import MiaOrb from '@/components/MiaOrb';
import { cn } from '@/lib/utils';

type MemoryBoxCardProps = {
  childFirstName?: string;
  className?: string;
};

/**
 * "You might hear back" note shown on the Add a message step (OTC prototype,
 * step 3). Sits in the left pane on desktop and under the composer on mobile.
 */
function MemoryBoxCard({ childFirstName, className }: MemoryBoxCardProps) {
  const parent = childFirstName ? `${childFirstName}'s parent` : 'their parent';

  return (
    <div
      data-testid='memory-box-card'
      className={cn(
        'flex shrink-0 items-center gap-[13px] rounded-2xl border border-[#ebe7df] bg-[#fbfaf9] px-[15px] py-3.5 text-left',
        className,
      )}
    >
      <div className='flex size-11 shrink-0 items-center justify-center'>
        <MiaOrb size={44} mood='idle' />
      </div>
      <div className='min-w-0 flex-1'>
        <span className='text-[10.5px] font-bold tracking-[0.05em] text-[#256956] uppercase'>
          Memory Box
        </span>
        <p className='mt-0.5 text-[14.5px] leading-[1.3] font-bold text-[#1a201d]'>
          You might hear back
        </p>
        <p className='mt-[3px] text-[12.5px] leading-[1.45] text-[#5a635e]'>
          When {parent} gets your message they can reply straight to you – via
          WhatsApp, text or email.
        </p>
      </div>
    </div>
  );
}

export default MemoryBoxCard;
